import { ReactElement } from "react";
import UptoolLogo from "~icons/local/login";

export default function Layout({
  title,
  children,
}: {
  title: string;
  children: ReactElement;
}) {
  return (
    <div className="fixed w-screen h-screen flex flex-col">
      <div className="grow w-full bg-slate-100 flex flex-col justify-center items-center">
        <div className="w-full max-w-lg bg-white p-14 flex flex-col gap-8">
          <UptoolLogo className="self-center" />
          <div className="font-bold text-lg self-center">{title}</div>
          {children}
        </div>
      </div>
      <footer className="w-full h-3 bg-slate-500 flex justify-between p-3 items-center">
        <div className="text-xs text-white">@ 2025 Uptool Inc.</div>
      </footer>
    </div>
  );
}
